import { useCallback, useState } from "react";
import { LockedAutocomplete } from "@/components/LockedAutocomplete";
import type { AutocompleteOption } from "@/components/LockedAutocomplete";
import {
  TimesheetFlowFooter,
  TimesheetFlowFooterButton,
} from "@/features/timesheetFlow/components/TimesheetFlowFooter";
import {
  projectSearchHitToOption,
  projectSearchHitToPreset,
  TIMESHEET_PROJECT_PICKER_EMPTY,
  TIMESHEET_PROJECT_PICKER_PLACEHOLDER,
} from "@/features/timesheetFlow/lib/timesheetProjectPicker";
import {
  loadTimesheetProjectOptions,
  type ProjectSearchHit,
} from "@/features/timesheetFlow/timesheetFlowApi";
import type { TimesheetProjectPreset } from "@/features/timesheetFlow/timesheetFlowTypes";

export function ProjectPickerScreen({
  onSelect,
  onCancel,
}: {
  onSelect: (project: TimesheetProjectPreset) => void;
  onCancel: () => void;
}) {
  const [selected, setSelected] = useState<AutocompleteOption<ProjectSearchHit> | null>(null);

  const searchFn = useCallback(async (q: string) => {
    const hits = await loadTimesheetProjectOptions(q);
    return hits.map(projectSearchHitToOption);
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <div data-tour="stundennachweis-projekt">
      <LockedAutocomplete<ProjectSearchHit>
        label="Projekt"
        placeholder={TIMESHEET_PROJECT_PICKER_PLACEHOLDER}
        emptyText={TIMESHEET_PROJECT_PICKER_EMPTY}
        value={selected}
        loadOptions={searchFn}
        minChars={0}
        autoFocus
        onChange={setSelected}
      />
      </div>

      <TimesheetFlowFooter>
        <TimesheetFlowFooterButton type="button" variant="secondary" onClick={onCancel}>
          Abbrechen
        </TimesheetFlowFooterButton>
        <TimesheetFlowFooterButton
          type="button"
          data-tour="stundennachweis-projekt-weiter"
          disabled={!selected}
          onClick={() => selected && onSelect(projectSearchHitToPreset(selected.value))}
        >
          Weiter
        </TimesheetFlowFooterButton>
      </TimesheetFlowFooter>
    </div>
  );
}
